import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, NgModel } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { UmOrganizationViewModalComponent } from 'src/app/um/um-organization/um-organization-view-modal/um-organization-view-modal.component';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { DatePipe } from '@angular/common'
import { UserService } from '../../../../services/user.service';
import * as $ from 'jquery';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-eap-all-requests-view-modal',
  templateUrl: './eap-all-requests-view-modal.component.html',
  styleUrls: ['./eap-all-requests-view-modal.component.scss']
})
export class EapAllRequestsViewModalComponent implements OnInit {
  formFields;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  ProductRequestForm: UntypedFormGroup;
  recurrence: any;
  shippingAddress: any;
  billingAddress: any;
  isNewMode: boolean = true;
  ApplicationID: any;
  SelectedWeeksList: any = [];
  userType: string = "";
  RetrivalLabel: string = "";
  AddPlusRequired: boolean;
  QuantityUnits = [
    {
      "label": "Tablets",
      "value": "Tablets"
    },
    {
      "label": "Capsules",
      "value": "Capsules"
    },
    {
      "label": "Strips",
      "value": "Strips"
    },
    {
      "label": "Syrup",
      "value": "Syrup"
    },
    {
      "label": "Inhailer",
      "value": "Inhailer"
    }
  ];
  dosageFormulaOptions = [];
  optionsSelect = [];
  statusOptions = [];
  productNamesOptions = [];
  strengthValuesOptions = [
    {
      "label": "25",
      "value": 1
    },
    {
      "label": "50",
      "value": 2
    },
    {
      "label": "75",
      "value": 3
    }
  ];
  strengthAndUnitsOptions = [];
  ProductsMappedInfoList = [];
  SelectedProductsMappedInfoList = [];
  fullFillmentTypeOptions = [];
  patientIdOptions = [];
  shippingAddressOptions = [];
  ProductshippingAddressOptions = [];
  recurrenceOptions = [
    {
      "label": "Daily",
      "value": "Daily"
    },
    {
      "label": "Weekly",
      "value": "Weekly"
    },
    {
      "label": "Monthly",
      "value": "Monthly"
    },
    {
      "label": "Yearly",
      "value": "Yearly"
    },
  ];
  repeatsEveryOptions = [
    {
      "label": "Monday",
      "value": "1"
    },
    {
      "label": "Tuesday",
      "value": "2"
    },
    {
      "label": "Wednesday",
      "value": "3"
    },
    {
      "label": "Thursday",
      "value": "4"
    },
    {
      "label": "Friday",
      "value": "5"
    },
    {
      "label": "Saturday",
      "value": "6"
    },
    {
      "label": "Sunday",
      "value": "7"
    }

  ];

  public StatusStr = "";


  myDate = new Date();

  myDate1 = new Date();
  tomorrow = new Date(this.myDate1.setDate(new Date().getDate() + 1))
  yesterday = new Date(this.myDate1.setDate(new Date().getDate()))

  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgModel,
    private datashareService: IstDataShareService,
    public datepipe: DatePipe,
    private userService: UserService,
    private commonService:CommonService
  ) {
  }

  ngOnInit() {
    this.AddPlusRequired = true;
    this.datashareService.ApplicationID.subscribe(x => {
       ;
      this.ApplicationID = x;
    });
    this.userType = this.userService.getUserType();
    this.summaryService.getSummaryData("api/EAPAllRequests/GetProductMasterDropData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.content.id).subscribe(result => {
       
      this.productNamesOptions = result["MasterData1"];
      this.dosageFormulaOptions = result["MasterData2"];
      this.strengthAndUnitsOptions = result["MasterData3"];
      this.patientIdOptions = result["MasterData4"];
      this.shippingAddressOptions = result["MasterData5"];
      this.ProductsMappedInfoList = result["ProductDropdown"];

      if (result["MasterData6"] != null && result["MasterData6"] != undefined) {
        var data = this.ProductsMappedInfoList.filter(x => x.value == result["MasterData6"][0].value)[0];
        if (data != null && data != undefined) {
           ;
          if (data.ISAllowShipmentToReporter && data.ISAllowShipmentToAuthorised) {
            this.fullFillmentTypeOptions = [{
              "label": "Shipping Address",
              "value": 1
            }, {
              "label": "Partner Network",
              "value": 2
            }
            ];
          }
          else if (data.ISAllowShipmentToReporter && data.ISAllowShipmentToAuthorised == false) {
            this.fullFillmentTypeOptions = [{ "label": "Shipping Address", "value": 1 }];
          }
          else if (data.ISAllowShipmentToReporter == false && data.ISAllowShipmentToAuthorised == true) {
            this.fullFillmentTypeOptions = [{ "label": "Partner Network", "value": 2 }];
          }
          this.SelectedProductsMappedInfoList = data.MappedNetworks;
          this.ProductRequestForm.controls["ShippingInstractionsIfAny"].setValue(data.StorageInstructions);
          this.ProductRequestForm.controls["RequiredQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["AllocatedQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["UsedQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["ReturnQuantityUnits"].setValue(data.ProductUnits);
          this.ProductRequestForm.controls["ShippingInstractionsIfAny"].disable();
          this.ProductRequestForm.controls["RequiredQuantityUnits"].disable();
          this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
          this.ProductRequestForm.controls["UsedQuantityUnits"].disable();
          this.ProductRequestForm.controls["ReturnQuantityUnits"].disable();
        }

      }


      if (this.heading != "Add") {

        this.getProductInfo();
      }
      else {
        this.StatusStr = "Draft";
      }
    });

    this.ProductRequestForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      Application_ID: new UntypedFormControl(null),
      DosageFormul: new UntypedFormControl(null),
      ProductName: new UntypedFormControl(null),
      Strength: new UntypedFormControl(null),
      StrengthUnits: new UntypedFormControl(null),
      RequiredBy: new UntypedFormControl(null),
      FullFillmentType: new UntypedFormControl(null),
      PaitientID: new UntypedFormControl(null),
      BillingAddress: new UntypedFormControl(null),
      ShippingAddress: new UntypedFormControl(null),
      Recurrence: new UntypedFormControl(null),
      RepeatsEvery: new UntypedFormControl(null),
      IsEndsOn: new UntypedFormControl(false),
      EndsON: new UntypedFormControl(null),
      AfterNoOfOccurrences: new UntypedFormControl(null),
      AllocatedQuantity: new UntypedFormControl(null),
      AllocatedQuantityUnits: new UntypedFormControl(null),
      ShipmentTrackingID: new UntypedFormControl(null),
      ShipmentSericeProvider: new UntypedFormControl(null),
      BatchNumber: new UntypedFormControl(null),
      DateOfManufature: new UntypedFormControl(null),
      DateOFExpires: new UntypedFormControl(null),
      DateOFDispatch: new UntypedFormControl(null),
      ShippingnsrucionsIFAny: new UntypedFormControl(null),
      RequiredQuantity: new UntypedFormControl(null),
      RequiredQuantityUnits: new UntypedFormControl(null),
      UsedQuantity: new UntypedFormControl(null),
      UsedQuantityUnits: new UntypedFormControl(null),
      DateOFRecept: new UntypedFormControl(null),
      ReturnQuantity: new UntypedFormControl(null),
      ReturnQuantityUnits: new UntypedFormControl(null),
      ShipmentNumber: new UntypedFormControl(null),
      returnShipmentServiceProvider: new UntypedFormControl(null),
      returnDateOFDispatch: new UntypedFormControl(null),
      returnDateOfRecept: new UntypedFormControl(null),
      Notes: new UntypedFormControl(null),
      ShippingInstractionsIfAny: new UntypedFormControl(null),
      Status: new UntypedFormControl(0)
    });


  }

  getProductInfo() {
     ;
    this.summaryService.getScreenDataForEdit("api/EAPAllRequests/EditProduct?RecordID=" + this.content.id).subscribe(result => {
       ;

      this.StatusStr = result["StatusStr"];
      this.RetrivalLabel = result["RetrivalLabel"];
      var formtedData = this.dataFormateMethod(result);


       ;
      setTimeout(() => {
        this.ShippingAddressChange(result["ShippingAddress"]);
        this.BillingAddressChange(result["BillingAddress"]);

        document.body.click();
      }, 2000)

    //  this.ProductRequestForm.patchValue(formtedData);

      this.ProductRequestForm.patchValue({
        ID: formtedData["ID"],
        Application_ID: formtedData["Application_ID"],
        DosageFormul: formtedData["DosageFormul"],
        ProductName: formtedData["ProductName"],
        Strength: formtedData["Strength"],
        StrengthUnits: formtedData["StrengthUnits"],
        RequiredBy: formtedData["RequiredBy"],
        FullFillmentType: formtedData["FullFillmentType"],
        PaitientID: formtedData["PaitientID"],
        BillingAddress: formtedData["BillingAddress"],
        ShippingAddress: formtedData["ShippingAddress"],
        Recurrence: formtedData["Recurrence"],
        RepeatsEvery: formtedData["RepeatsEvery"],
        IsEndsOn: formtedData["IsEndsOn"],
        EndsON: formtedData["EndsON"],
        AfterNoOfOccurrences: formtedData["AfterNoOfOccurrences"],
        AllocatedQuantity: formtedData["AllocatedQuantity"],
       // AllocatedQuantityUnits: formtedData["ID"],
        ShipmentTrackingID: formtedData["ShipmentTrackingID"],
        ShipmentSericeProvider: formtedData["ShipmentSericeProvider"],
        BatchNumber: formtedData["BatchNumber"],
        DateOfManufature: formtedData["DateOfManufature"],
        DateOFExpires: formtedData["DateOFExpires"],
        DateOFDispatch: formtedData["DateOFDispatch"],
       // ShippingnsrucionsIFAny: formtedData["ID"],
        RequiredQuantity: formtedData["RequiredQuantity"],
       // RequiredQuantityUnits: formtedData["ID"],
        UsedQuantity: formtedData["UsedQuantity"],
      //  UsedQuantityUnits: formtedData["ID"],
        DateOFRecept: formtedData["DateOFRecept"],
        ReturnQuantity: formtedData["ReturnQuantity"],
      //  ReturnQuantityUnits: formtedData["ID"],
        ShipmentNumber: formtedData["ShipmentNumber"],
        returnShipmentServiceProvider: formtedData["returnShipmentServiceProvider"],
        returnDateOFDispatch: formtedData["returnDateOFDispatch"],
        returnDateOfRecept: formtedData["returnDateOfRecept"],
        Notes: formtedData["Notes"],
      //  ShippingInstractionsIfAny: formtedData["ShippingInstractionsIfAny"],
        Status: formtedData["Status"],
      });

      this.ProductChange(formtedData["ProductName"], formtedData["FullFillmentType"]);
      this.disabledControls(result["Status"], formtedData);



    });
  }

  dataFormateMethod(formData: any) {
    if (formData != null) {
      if (formData["RequiredBy"] != null && formData["RequiredBy"] != undefined) {
        formData["RequiredBy"] = this.datepipe.transform(formData["RequiredBy"], 'dd-MMM-yyyy');
      }
      if (formData["EndsON"] != null && formData["EndsON"] != undefined) {
        formData["EndsON"] = this.datepipe.transform(formData["EndsON"], 'dd-MMM-yyyy');
      }
      if (formData["DateOfManufature"] != null && formData["DateOfManufature"] != undefined) {
        formData["DateOfManufature"] = this.datepipe.transform(formData["DateOfManufature"], 'dd-MMM-yyyy');
      }
      if (formData["DateOFExpires"] != null && formData["DateOFExpires"] != undefined) {
        formData["DateOFExpires"] = this.datepipe.transform(formData["DateOFExpires"], 'dd-MMM-yyyy');
      }
      if (formData["DateOFDispatch"] != null && formData["DateOFDispatch"] != undefined) {
        formData["DateOFDispatch"] = this.datepipe.transform(formData["DateOFDispatch"], 'dd-MMM-yyyy');
      }
      if (formData["DateOFRecept"] != null && formData["DateOFRecept"] != undefined) {
        formData["DateOFRecept"] = this.datepipe.transform(formData["DateOFRecept"], 'dd-MMM-yyyy');
      }
      if (formData["returnDateOFDispatch"] != null && formData["returnDateOFDispatch"] != undefined) {
        formData["returnDateOFDispatch"] = this.datepipe.transform(formData["returnDateOFDispatch"], 'dd-MMM-yyyy');
      }
      if (formData["returnDateOfRecept"] != null && formData["returnDateOfRecept"] != undefined) {
        formData["returnDateOfRecept"] = this.datepipe.transform(formData["returnDateOfRecept"], 'dd-MMM-yyyy');
      }

    }
    return formData;
  }
  disabledControls(status: any, formtedData: any) {

    if (status == 5) {
      this.ProductRequestForm.controls["AllocatedQuantity"].disable();
      this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
      this.ProductRequestForm.controls["ShipmentTrackingID"].disable();
      this.ProductRequestForm.controls["ShipmentSericeProvider"].disable();

      this.ProductRequestForm.controls["BatchNumber"].disable();
      this.ProductRequestForm.controls["DateOfManufature"].disable();
      this.ProductRequestForm.controls["DateOFExpires"].disable();

      this.ProductRequestForm.controls["ShippingInstractionsIfAny"].disable();
      this.ProductRequestForm.controls["DateOFDispatch"].disable();
      this.AddPlusRequired = false;

    }
   if (status == 7 || status == 8 || status == 4) {
      this.ProductRequestForm.disable();
      this.heading = "View";
      this.AddPlusRequired = false;
    }
     if (status > 2) {
      this.ProductRequestForm.controls["ProductName"].disable();
      this.ProductRequestForm.controls["DosageFormul"].disable();
      this.ProductRequestForm.controls["Strength"].disable();
      this.ProductRequestForm.controls["StrengthUnits"].disable();
      this.ProductRequestForm.controls["RequiredQuantity"].disable();
      this.ProductRequestForm.controls["RequiredQuantity"].disable();
      this.ProductRequestForm.controls["RequiredQuantityUnits"].disable();
      this.ProductRequestForm.controls["RequiredBy"].disable();
      this.ProductRequestForm.controls["FullFillmentType"].disable();
      this.ProductRequestForm.controls["PaitientID"].disable();
      this.ProductRequestForm.controls["ShippingAddress"].disable();
      this.ProductRequestForm.controls["BillingAddress"].disable();
      this.AddPlusRequired = false;

    }
    if (this.userType == "I") {
      this.ProductRequestForm.controls["UsedQuantity"].disable();
      this.ProductRequestForm.controls["UsedQuantityUnits"].disable();
      this.ProductRequestForm.controls["DateOFRecept"].disable();
      this.ProductRequestForm.controls["ReturnQuantity"].disable();
      this.ProductRequestForm.controls["ReturnQuantityUnits"].disable();
      this.ProductRequestForm.controls["returnShipmentServiceProvider"].disable();
      this.ProductRequestForm.controls["ShipmentNumber"].disable();
      this.ProductRequestForm.controls["Notes"].disable();
      if (formtedData.ReturnQuantity != null && formtedData.ReturnQuantity != undefined)
        this.ProductRequestForm.controls["returnDateOfRecept"].enable();
      else
        this.ProductRequestForm.controls["returnDateOfRecept"].disable();
    }
    else {
      this.ProductRequestForm.controls["returnDateOfRecept"].disable();
      this.ProductRequestForm.controls["AllocatedQuantity"].disable();
      this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
      this.ProductRequestForm.controls["ShipmentTrackingID"].disable();
      this.ProductRequestForm.controls["ShipmentSericeProvider"].disable();
      this.ProductRequestForm.controls["BatchNumber"].disable();
      this.ProductRequestForm.controls["DateOfManufature"].disable();
      this.ProductRequestForm.controls["DateOFExpires"].disable();
      this.ProductRequestForm.controls["DateOFDispatch"].disable();
      this.ProductRequestForm.controls["ShippingnsrucionsIFAny"].disable();
    }

    if (this.heading == "View") {
      this.ProductRequestForm.disable();
    }

  }
  addNewOrg() {
     ;
    //let modalRef = this.modalService.show(IstStudyTeamOrganizationViewModalComponent, {
    //  backdrop: false,
    //  keyboard: false,
    //  ignoreBackdropClick: true,
    //  class: 'modal-vlg modal-full-height modal-right',
    //  animated: true,
    //  data: {
    //    heading: 'Add',
    //    content: { id: "", ApplicationID: "" },

    //  }
    //});

    //modalRef.content.action.subscribe(result => {
    //  this.summaryService.getSummaryData("api/EAPAllRequests/GetProductMasterDropData?ApplicationID=" + this.ApplicationID).subscribe(result => {
    //    this.shippingAddressOptions = result["MasterData5"];
    //  });
    //})
  }
  //addOrg() {
  //  this.modalService.show(IstStudyTeamOrganizationViewModalComponent, {
  //    backdrop: false,
  //    keyboard: false,
  //    ignoreBackdropClick: true,
  //    class: 'modal-vlg modal-full-height modal-right',
  //    animated: true,
  //    data: {
  //      heading: 'Add',
  //      content: null
  //    }
  //  });
  //}

  SaveProductInfo() {
    if (this.validateControls()) {
       ;
      var formData = this.ProductRequestForm.value;
       ;
      formData["Application_ID"] = this.ApplicationID;
      if (formData["Strength"] != null && formData["Strength"] != undefined) {
        formData["Strength"] = parseInt(formData["Strength"]);
      }
      if (formData["FullFillmentType"] != null && formData["FullFillmentType"] != undefined) {
        formData["FullFillmentType"] = parseInt(formData["FullFillmentType"]);
      }
      if (formData["AllocatedQuantity"] != null && formData["AllocatedQuantity"] != undefined) {
        formData["AllocatedQuantity"] = parseInt(formData["AllocatedQuantity"]);
      }
      if (formData["RequiredQuantity"] != null && formData["RequiredQuantity"] != undefined) {
        formData["RequiredQuantity"] = parseInt(formData["RequiredQuantity"]);
      }
      if (formData["UsedQuantity"] != null && formData["UsedQuantity"] != undefined) {
        formData["UsedQuantity"] = parseInt(formData["UsedQuantity"]);
      }
      if (formData["UsedQuantity"] != null && formData["UsedQuantity"] != undefined) {
        formData["UsedQuantity"] = parseInt(formData["UsedQuantity"]);
      }
      if (formData["ReturnQuantity"] != null && formData["ReturnQuantity"] != undefined) {
        formData["ReturnQuantity"] = parseInt(formData["ReturnQuantity"]);
      }
      if (formData["RequiredBy"] != null && formData["RequiredBy"] != undefined) {
        formData["RequiredBy"] = new Date(formData["RequiredBy"]);
        const ldate = new Date(formData["RequiredBy"]);
        formData["STR_RequiredBy"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }
      if (formData["EndsON"] != null && formData["EndsON"] != undefined) {
        formData["EndsON"] = new Date(formData["EndsON"]);
        const ldate = new Date(formData["EndsON"]);
        formData["STR_EndsON"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      }
      if (formData["DateOfManufature"] != null && formData["DateOfManufature"] != undefined) {
        formData["DateOfManufature"] = new Date(formData["DateOfManufature"]);
        const ldate = new Date(formData["DateOfManufature"]);
        formData["STR_DateOfManufature"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      }
      if (formData["DateOFExpires"] != null && formData["DateOFExpires"] != undefined) {
        formData["DateOFExpires"] = new Date(formData["DateOFExpires"]);
        const ldate = new Date(formData["DateOFExpires"]);
        formData["STR_DateOFExpires"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      }
      if (formData["DateOFDispatch"] != null && formData["DateOFDispatch"] != undefined) {
        formData["DateOFDispatch"] = new Date(formData["DateOFDispatch"]);
        const ldate = new Date(formData["DateOFDispatch"]);
        formData["STR_DateOFDispatch"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      }
      if (formData["DateOFRecept"] != null && formData["DateOFRecept"] != undefined) {
        formData["DateOFRecept"] = new Date(formData["DateOFRecept"]);
        const ldate = new Date(formData["DateOFRecept"]);
        formData["STR_DateOFRecept"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      }
      if (formData["returnDateOFDispatch"] != null && formData["returnDateOFDispatch"] != undefined) {
        formData["returnDateOFDispatch"] = new Date(formData["returnDateOFDispatch"]);
        const ldate = new Date(formData["returnDateOFDispatch"]);
        formData["STR_returnDateOFDispatch"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      }
      if (formData["returnDateOfRecept"] != null && formData["returnDateOfRecept"] != undefined) {
        formData["returnDateOfRecept"] = new Date(formData["returnDateOfRecept"]);
        const ldate = new Date(formData["returnDateOfRecept"]);
        formData["STR_returnDateOfRecept"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      }
      if (formData["IsEndsOn"] == "IsEndsOn") {
        formData["IsEndsOn"] = "Yes";
      }
      else {
        formData["IsEndsOn"] = "No";
      }
      if (formData["ISnoOfOccurances"] == false) {
        formData["ISnoOfOccurances"] = "No";
      }
      else {
        formData["ISnoOfOccurances"] = "Yes";
      }
      formData["SelectedWeeks"] = this.SelectedWeeksList.join(",");

      if (this.heading === 'Add') {
        this.summaryService.Insert("api/EAPAllRequests/InsertProduct", formData).subscribe(result => {
          this.commonService.SuccessBanner('Data has been inserted successfully.')
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });

          this.modalRef.close();
        })

      } else if (this.heading === 'Edit') {
        this.summaryService.Insert("api/EAPAllRequests/UpdateProduct", formData).subscribe(result => {
          this.commonService.SuccessBanner('Data has been inserted successfully.')
          // this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been Updated successfully.' } } });

          this.modalRef.close();
        })
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ProductRequestForm.value;
    if (formData.ProductName === null || formData.ProductName === "") {
      $("#ProductName").addClass("ng-touched ng-invalid validate-error");
      $("#ProductName").removeClass("ng-untouched ng-valid");
      message += "Please select Product Name.<br/>";
      isValid = false;
    } else {
      $("#ProductName").addClass("ng-untouched ng-valid");
      $("#ProductName").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.ShippingAddress === null || formData.ShippingAddress === "") {
      $("#ShippingAddress").addClass("ng-touched ng-invalid validate-error");
      $("#ShippingAddress").removeClass("ng-untouched ng-valid");
      message += "Please select Shipping Address / Partner Network.<br/>";
      isValid = false;
    } else {
      $("#ShippingAddress").addClass("ng-untouched ng-valid");
      $("#ShippingAddress").removeClass("ng-touched ng-invalid validate-error");
    }


    if (formData.BillingAddress === null || formData.BillingAddress === "") {
      $("#BillingAddress").addClass("ng-touched ng-invalid validate-error");
      $("#BillingAddress").removeClass("ng-untouched ng-valid");
      message += "Please select Billing Address.<br/>";
      isValid = false;
    } else {
      $("#BillingAddress").addClass("ng-untouched ng-valid");
      $("#BillingAddress").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.NOTES === null || formData.NOTES === "") {
      $("#NOTES").addClass("ng-touched ng-invalid validate-error");
      $("#NOTES").removeClass("ng-untouched ng-valid");
      message += "Please enter Notes.<br/>";
      isValid = false;
    } else {
      $("#NOTES").addClass("ng-untouched ng-valid");
      $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
    }

    formData.UsedQuantity = $("#UsedQuantity").val();
    if (formData.UsedQuantity !== null && formData.UsedQuantity !== "" && formData.UsedQuantity !== undefined) {
      const phoneformat = /^[1-9]\d*$/;
      formData.UsedQuantity = formData.UsedQuantity + "";
      if (formData.UsedQuantity.match(phoneformat)) {
        $("#UsedQuantity").addClass("ng-untouched ng-valid");
        $("#UsedQuantity").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#UsedQuantity").addClass("ng-touched ng-invalid validate-error");
        $("#UsedQuantity").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Used Quantity.<br/>";
        isValid = false;
      }
      var IsDone = false;
      var quantity1 = this.ProductRequestForm.controls["RequiredQuantity"].value;
      var Allocated = $("#AllocatedQuantity").val();
      if (quantity1 != null && quantity1 != undefined) {
        var Reqquantity12 = parseFloat(quantity1);
        var Allquantity13 = parseFloat(formData.UsedQuantity);
        if (Allquantity13 > Reqquantity12) {
          $("#UsedQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#UsedQuantity").removeClass("ng-untouched ng-valid");
          message += "Used Quantity should not greater than Required Quantity.<br/>";
          isValid = false;
          IsDone = true;
        }
      }

      if (Allocated != null && Allocated != undefined && IsDone==false) {
        var Allocated1 = parseFloat(Allocated);
        var used = parseFloat(formData.UsedQuantity);
        if (used > Allocated1) {
          $("#UsedQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#UsedQuantity").removeClass("ng-untouched ng-valid");
          message += "Used Quantity should not greater than Allocated Quantity.<br/>";
          isValid = false;
        }
      }
    }
    formData.Strength = $("#Strength").val();
    if (formData.Strength !== null && formData.Strength !== "" && formData.Strength !== undefined) {
      const phoneformat = /^[1-9]\d*$/;
      formData.Strength = formData.Strength + "";
      if (formData.Strength.match(phoneformat)) {
        $("#Strength").addClass("ng-untouched ng-valid");
        $("#Strength").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#Strength").addClass("ng-touched ng-invalid validate-error");
        $("#Strength").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Strength & Units.<br/>";
        isValid = false;
      }
    }
    formData.RequiredQuantity = $("#RequiredQuantity").val();
    if (formData.RequiredQuantity !== null && formData.RequiredQuantity !== "" && formData.RequiredQuantity !== undefined) {
      const phoneformat = /^[1-9]\d*$/;
      formData.RequiredQuantity = formData.RequiredQuantity + "";
      if (formData.RequiredQuantity.match(phoneformat)) {
        $("#RequiredQuantity").addClass("ng-untouched ng-valid");
        $("#RequiredQuantity").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#RequiredQuantity").addClass("ng-touched ng-invalid validate-error");
        $("#RequiredQuantity").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Required Quantity.<br/>";
        isValid = false;
      }
    }

    formData.AllocatedQuantity = $("#AllocatedQuantity").val();
    if (formData.AllocatedQuantity !== null && formData.AllocatedQuantity !== "" && formData.AllocatedQuantity !== undefined) {
      const phoneformat = /^[1-9]\d*$/;
      formData.AllocatedQuantity = formData.AllocatedQuantity + "";
      if (formData.AllocatedQuantity.match(phoneformat)) {
        $("#AllocatedQuantity").addClass("ng-untouched ng-valid");
        $("#AllocatedQuantity").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#AllocatedQuantity").addClass("ng-touched ng-invalid validate-error");
        $("#AllocatedQuantity").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Allocated Quantity.<br/>";
        isValid = false;
      }
      var quantity = this.ProductRequestForm.controls["RequiredQuantity"].value;
      if (quantity != null && quantity != undefined) {
        var Reqquantity1 = parseFloat(quantity);
        var Allquantity1 = parseFloat(formData.AllocatedQuantity);
        if (Allquantity1 > Reqquantity1) {
          $("#AllocatedQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#AllocatedQuantity").removeClass("ng-untouched ng-valid");
          message += "Allocated Quantity should not greater than Required Quantity.<br/>";
          isValid = false;
        }
      }
    }

    formData.ReturnQuantity = $("#ReturnQuantity").val();
    var AllocatedR = $("#AllocatedQuantity").val();
    if (formData.ReturnQuantity !== null && formData.ReturnQuantity !== "" && formData.ReturnQuantity !== undefined) {
      const phoneformat = /^[1-9]\d*$/;
      formData.ReturnQuantity = formData.ReturnQuantity + "";
      if (formData.ReturnQuantity.match(phoneformat)) {
        $("#ReturnQuantity").addClass("ng-untouched ng-valid");
        $("#ReturnQuantity").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#ReturnQuantity").addClass("ng-touched ng-invalid validate-error");
        $("#ReturnQuantity").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Return Quantity.<br/>";
        isValid = false;
      }
      var isDone1 = false;
      var quantity = this.ProductRequestForm.controls["RequiredQuantity"].value;
      if (quantity != null && quantity != undefined) {
        var Reqquantity1 = parseFloat(quantity);
        var Allquantity1 = parseFloat(formData.ReturnQuantity);
        if (Allquantity1 > Reqquantity1) {
          $("#ReturnQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#ReturnQuantity").removeClass("ng-untouched ng-valid");
          message += "Return Quantity should not greater than Required Quantity.<br/>";
          isValid = false;
          isDone1 = true;
        }

      }
      if (AllocatedR != null && AllocatedR != undefined && isDone1==false) {
        var Allocated12 = parseFloat(AllocatedR);
        var retunQ = parseFloat(formData.ReturnQuantity);
        if (retunQ > Allocated12) {
          $("#ReturnQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#ReturnQuantity").removeClass("ng-untouched ng-valid");
          message += "Return Quantity should not greater than Allocated Quantity.<br/>";
          isValid = false;
        }
      }

      var allQty = $("#AllocatedQuantity").val();
      var usQty = $("#UsedQuantity").val();
      if (allQty != null && allQty != undefined && isDone1 == false && usQty != undefined && usQty != null) {
        var allQty1 = parseFloat(allQty);
        var usQty1 = parseFloat(usQty);
        var reQty = parseFloat(formData.ReturnQuantity);
        if (allQty1 != (reQty + usQty1)) {
          $("#ReturnQuantity").addClass("ng-touched ng-invalid validate-error");
          $("#ReturnQuantity").removeClass("ng-untouched ng-valid");
          message += "Return Quantity should be in the Ratio of (Allocated Quantity-Used Quantity).<br/>";
          isValid = false;
        }
      }
    }


    if (!isValid)
    this.commonService.ValidationBanner(message);
     // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }
  ShippingAddressChange(data1) {
    var data = this.ProductshippingAddressOptions.filter(x => x.value == data1)[0];
    var addressList = [];
    if (data != null && data != undefined) {
      addressList = data.label.split(",");
    }
    this.shippingAddress = new Object();
    this.shippingAddress["Address"] = "";
    this.shippingAddress["City"] = "";
    this.shippingAddress["State"] = "";
    this.shippingAddress["Country"] = "";
    this.shippingAddress["PostalCode"] = "";
    if (addressList.length > 0) {
      this.shippingAddress["Address"] = addressList[0];
      this.shippingAddress["City"] = addressList[1];
      this.shippingAddress["State"] = addressList[2];
      this.shippingAddress["Country"] = addressList[3];
      this.shippingAddress["PostalCode"] = addressList[4];
    }
  }
  ProductChange(data,param) {
     ;
    if (param == "drop") {
      var data = this.ProductsMappedInfoList.filter(x => x.value == data)[0];
      if (data != null && data != undefined) {
         ;
        if (data.ISAllowShipmentToReporter && data.ISAllowShipmentToAuthorised) {
          this.fullFillmentTypeOptions = [{
            "label": "Shipping Address",
            "value": 1
          }, {
            "label": "Partner Network",
            "value": 2
          }
          ];
        }
        else if (data.ISAllowShipmentToReporter && data.ISAllowShipmentToAuthorised == false) {
          this.fullFillmentTypeOptions = [{ "label": "Shipping Address", "value": 1 }];
        }
        else if (data.ISAllowShipmentToReporter == false && data.ISAllowShipmentToAuthorised == true) {
          this.fullFillmentTypeOptions = [{ "label": "Partner Network", "value": 2 }];
        }
        this.SelectedProductsMappedInfoList = data.MappedNetworks;
        this.ProductRequestForm.controls["ShippingInstractionsIfAny"].setValue(data.StorageInstructions);
        this.ProductRequestForm.controls["RequiredQuantityUnits"].setValue(data.ProductUnits);
        this.ProductRequestForm.controls["AllocatedQuantityUnits"].setValue(data.ProductUnits);
        this.ProductRequestForm.controls["UsedQuantityUnits"].setValue(data.ProductUnits);
        this.ProductRequestForm.controls["ReturnQuantityUnits"].setValue(data.ProductUnits);
        this.ProductRequestForm.controls["ShippingInstractionsIfAny"].disable();
        this.ProductRequestForm.controls["RequiredQuantityUnits"].disable();
        this.ProductRequestForm.controls["AllocatedQuantityUnits"].disable();
        this.ProductRequestForm.controls["UsedQuantityUnits"].disable();
        this.ProductRequestForm.controls["ReturnQuantityUnits"].disable();
      }
    }
    else {
      this.FullfillmentChange(param);
    }

  }
  FullfillmentChange(data) {
    if (data == 1) {
      this.ProductshippingAddressOptions = this.shippingAddressOptions;
    }
    else if (data == 2) {
      this.ProductshippingAddressOptions = this.SelectedProductsMappedInfoList;
    }
  }
BillingAddressChange(data1) {
  var data = this.shippingAddressOptions.filter(x => x.value == data1)[0];
  var addressList = [];
  if (data != null && data != undefined) {
    addressList = data.label.split(",");
  }
  this.billingAddress = new Object();
  this.billingAddress["Address"] = "";
  this.billingAddress["City"] = "";
  this.billingAddress["State"] = "";
  this.billingAddress["Country"] = "";
  this.billingAddress["PostalCode"] = "";
  if (addressList.length > 0) {
    this.billingAddress["Address"] = addressList[0];
    this.billingAddress["City"] = addressList[1];
    this.billingAddress["State"] = addressList[2];
    this.billingAddress["Country"] = addressList[3];
    this.billingAddress["PostalCode"] = addressList[4];
  }
}
SelectWeek(option) {
   ;
  if (this.SelectedWeeksList.indexOf(option) == -1) {
    this.SelectedWeeksList.push(option);
  }
  else {
    var index = this.SelectedWeeksList.indexOf(option);
    this.SelectedWeeksList.splice(index, 1);
  }
}

}
